
import { getAuth } from '@/services/authService'
const c = getAuth();

const o = require('object-encrypt-decrypt')
let r = null

if (c && c.hasOwnProperty('whitelabel') && c.whitelabel && c.whitelabel.hasOwnProperty('w') && c.whitelabel.w && c.whitelabel.w.hasOwnProperty('config') && c.whitelabel.w.config) {
  r = o.decrypt(c.whitelabel.w.config);
  console.log('R', r)
  if (typeof r == 'string')
    r = JSON.parse(r)
  const sq = {
    
  }
  const ss = o.encrypt(sq)
  console.log('ss', ss)
}
else {
  r = null
}




export default r